import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { RequireSection } from '@/shared/routing';

import { ContentPagesPage } from './ui/pages/ContentPagesPage';

/** Storefront content pages, behind one `content.view` guard. */
export const contentRoutes: RouteObject = {
  path: 'content',
  element: <RequireSection section="content" />,
  children: [
    { index: true, element: <Navigate to="/content/pages" replace /> },
    { path: 'pages', element: <ContentPagesPage /> },
    { path: 'pages/:slug', element: <ContentPagesPage /> },
    { path: '*', element: <Navigate to="/content/pages" replace /> },
  ],
};

